// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d7ef5eef","453":"022f15dc","454":"a6dc1a62","455":"3fa9f13a","933":"19c46ca3","977":"4b1093e3"}[chunkId] + ".chunk.js";
};